import type { ReactNode } from 'react';
import { useGlobalProvider } from '../../context/GlobalContext';
import { Drawer } from '@mui/material';

export const NOTES_PANEL_WIDTH = 400;

/** Sticky toolbar height (tab row + padding + bottom border) — drawer sits flush underneath. */
export const SIDE_PANEL_TOOLBAR_OFFSET = 53;

interface RightSideBarProps {
  children: ReactNode;
  /** When set, drawer paper is positioned below this offset (e.g. toolbar height). */
  contentOffsetTop?: number;
}

export const RightSideBar = ({ children, contentOffsetTop }: RightSideBarProps) => {
  const { rightSideBarOpen } = useGlobalProvider();
  const top = contentOffsetTop ?? SIDE_PANEL_TOOLBAR_OFFSET;
  const paperHeight = top > 0 ? `calc(100vh - ${top}px)` : '100%';

  return (
    <Drawer
      variant="persistent"
      anchor="right"
      open={rightSideBarOpen}
      sx={{
        width: rightSideBarOpen ? NOTES_PANEL_WIDTH : 0,
        zIndex: 1000,
        flexShrink: 0,
        height: '100%',
        alignSelf: 'stretch',
        '& .MuiDrawer-paper': {
          width: NOTES_PANEL_WIDTH,
          boxSizing: 'border-box',
          borderRadius: 0,
          transition: 'width 0.3s',
          overflow: 'hidden',
          borderLeft: '2px solid',
          borderColor: 'divider',
          boxShadow: '-2px 0 6px rgba(0, 0, 0, 0.06)',
          backgroundColor: '#FFF',
          top: top,
          height: paperHeight,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      {children}
    </Drawer>
  );
};